<script setup lang="ts">
import { inject }               from "vue";
import type { TypeCommonProps } from "@ViewPages/Main/Components/commonTypes";
import Menu                     from "@ViewPages/Main/Components/Header/Menu.vue";

const props = inject<TypeCommonProps>('header_props');
</script>

<template>
    <div class="header__top flex items-center xl:justify-between gap-x-2 xl:gap-x-4 mb-4">
        <div class="logo" v-html="props?.logo_img_tag"></div>

        <div class="tel xl:hidden shrink-0">
            <a class="text-sm md:text-base xl:text-lg"
               :href="'tel:' + props?.tel.replace(/\D+/g, '')">
                {{ props?.tel }}
            </a>
        </div>

        <Menu></Menu>
    </div>
</template>

<style scoped>

</style>
